import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { ValidationService } from '../../core/services/validation/validation.service';
import { HttpService  } from '../../core/services/http/http.service';
import { Store } from '@ngrx/store';
import { Login, Logout } from '../../../store/actions/authenticationActions';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private subject = new Subject<any>();

  constructor(private http: HttpService, private store: Store<any>) { }
  static formFields() {
    return {
      'email': [null, Validators.compose([Validators.required, ValidationService.emailValidator])],
      'password': [null, Validators.compose([Validators.required, ValidationService.passwordValidator])],

    }
  }

  sendMessage(message: boolean) {
    this.subject.next(message);
  }

  getMessage(): Observable<boolean> {
    return this.subject.asObservable();
  }
  
  login(data)
  {
   return this.http.query('post', 'login', {}, '', data );
  }

  dispatchLoginAction(payload)
  {
    this.store.dispatch(new Login(payload));
  }

  logout()
  {
    return this.http.query('get', 'logout', {});
  }

  dispatchLogoutAction(payload)
  {
    this.store.dispatch(new Logout(payload));
  }
  loginUser(user) {

    return this.http.query('post', 'login', {}, '', user , 'openId');
  
  }
}
